var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item.reason_code)?_c('div',{staticClass:"tag tag--dark tooltip",attrs:{"data-tooltip":_vm.item.reason_name}},[_c('strong',[_vm._v(_vm._s(_vm.item.reason_code))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }